import type { LearningProgressRepository } from '@/domain/precon-supporter/learning-progress';
import { CourseId } from '@/domain/precon-supporter/value-objects';

export interface ResetExaminationUseCaseInput {
  courseId: CourseId;
}

/**
 * 修了テスト合格状態をリセットするユースケース
 * 認証エラー（403）などで期限切れの場合に使用
 */
export class ResetExaminationUseCase {
  constructor(private learningProgressRepository: LearningProgressRepository) {}

  async execute(input: ResetExaminationUseCaseInput): Promise<void> {
    const { courseId } = input;

    // 既存の進捗を取得
    const progress =
      await this.learningProgressRepository.findByCourseId(courseId);

    if (!progress) {
      // 進捗が存在しない場合は何もしない
      return;
    }

    // 修了テスト合格状態をリセット
    const resetProgress = progress.resetExaminationPassed();

    // 保存
    await this.learningProgressRepository.save(resetProgress);
  }
}
